import { useState, useEffect } from "react";
import { cn } from "@/lib/utils";
import logoWhite from "@/assets/logo-white.svg";

interface TVFooterProps {
  variant?: "light" | "dark";
}

export function TVFooter({ variant = "light" }: TVFooterProps) {
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  const time = now.toLocaleTimeString("nb-NO", { hour: "2-digit", minute: "2-digit" });
  const date = now.toLocaleDateString("nb-NO", { weekday: "long", day: "numeric", month: "long" });
  const isDark = variant === "dark";

  return (
    <div className={cn("flex items-center justify-between px-2 py-2", isDark ? "text-white/60" : "text-muted-foreground")}>
      <span className="text-sm font-medium capitalize">{date}</span>
      <div className="flex items-center gap-2">
        <img
          src={logoWhite}
          alt="Sølvrev"
          className={cn("w-4 h-4", isDark ? "opacity-40" : "opacity-30 invert")}
        />
        <span className="font-display text-sm tracking-wider">Sølvrev</span>
      </div>
      <span className="text-sm font-medium tabular-nums">{time}</span>
    </div>
  );
}
